var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2199_78927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4H4.005M1 2.6L1 4.83726C1 5.08185 1 5.20414 1.02763 5.31923C1.05213 5.42127 1.09253 5.51881 1.14736 5.60828C1.2092 5.7092 1.29568 5.79568 1.46863 5.96863L5.30294 9.80294C5.89697 10.397 6.19398 10.694 6.53647 10.8053C6.83774 10.9031 7.16226 10.9031 7.46352 10.8053C7.80602 10.694 8.10303 10.397 8.69706 9.80294L9.80294 8.69706C10.397 8.10303 10.694 7.80602 10.8053 7.46352C10.9031 7.16226 10.9031 6.83774 10.8053 6.53647C10.694 6.19398 10.397 5.89697 9.80294 5.30294L5.96863 1.46863C5.79568 1.29568 5.7092 1.2092 5.60828 1.14736C5.51881 1.09253 5.42127 1.05213 5.31923 1.02763C5.20414 1 5.08185 1 4.83726 1L2.6 1C2.03995 1 1.75992 1 1.54601 1.10899C1.35785 1.20487 1.20487 1.35785 1.10899 1.54601C1 1.75992 1 2.03995 1 2.6ZM4.25 4C4.25 4.13807 4.13807 4.25 4 4.25C3.86193 4.25 3.75 4.13807 3.75 4C3.75 3.86193 3.86193 3.75 4 3.75C4.13807 3.75 4.25 3.86193 4.25 4Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2199_78927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.ec4e723d6f3812de07f8f0ba5e189c22.svg";
export { ForwardRef as ReactComponent };